import { gql } from '@apollo/client/core';

/**
 * Shared by the rider read and the rider save, which the legacy module inlined separately and
 * kept in sync by hand.
 *
 * **Do not select `size` here.** It is `Int!` on `Attachment`, but the column is nil for the whole
 * window between `createDirectUploadUrl` (which builds the row with only `name`, `checksum` and
 * `mime`) and `ProcessS3AttachmentWorker` (which stores the file and is what finally writes
 * `size`). The Documents card attaches a document the moment its upload confirms — inside that
 * window — so selecting `size` made the backend answer the attach mutation with
 * `Cannot return null for non-nullable field Attachment.size`, `attachments: null` and a
 * top-level error. Apollo's default `errorPolicy: 'none'` rejects on that error even though the
 * payload carried `success: true`, so the store reported a failed upload for a document it had in
 * fact just persisted — which then appeared out of nowhere on the next save, once the worker had
 * filled `size` in. The read has the same window: reloading the tab mid-processing failed the
 * whole rider load.
 *
 * `checksum` is safe by contrast — the model validates it present and the presign writes it — and
 * nothing parses a rider attachment through the shared `attachmentSchema`, so neither field is
 * needed to keep that type honest. The card reads `id`, `name` and `url`. `status` stays selected
 * for the domain type's sake, but nothing binds to it since the standalone rider modal went.
 */
export const EVENT_ARTIST_RIDER_FIELDS = gql`
  fragment EventArtistRiderFields on EventArtistRider {
    id
    notes
    riderType
    artistLoadInTime
    stageSoundCheckTime
    soundCheckType
    stagePerformersNumber
    backstagePassesNumber
    attachments {
      id
      name
      mime
      checksum
      url
      status
    }
  }
`;
